import { Directus } from '@directus/sdk'

export function makeInstance(url, staticToken) {
  const auth = { mode: 'json', staticToken }
  return new Directus(url, { auth })
}

export function getTranslation(item, fieldName, currentLocale, clientLanguages) {
  for (const code of getFallbackLangs(currentLocale, clientLanguages)) {
    const translation = item.translations.find((el) => code === el.code)

    if (translation?.[fieldName]) {
      return translation[fieldName]
    }
  }

  return ''
}

export function getImage(item, currentLocale) {
  const translationObj = item.translations.find((el) => el.code === currentLocale)
  return translationObj?.image ?? item.image
}

export function getFallbackLangs(currentLocale, clientLanguages) {
  const fallback = clientLanguages.find((e) => e.primary)?.iso
  const ENGLISH = 'en'

  const langs = [currentLocale, fallback, ENGLISH].filter(Boolean)

  return [...new Set(langs)]
}
